import React from 'react';
import { Typography } from '@material-ui/core';
import Markdown from 'markdown-to-jsx';
import CreatorInfo from '../components/CreatorInfo';
import AutoPizzaViewer from '../components/AutoPizzaViewer';

export type Post = {
    BannerImage: string;
    Content: string;
    PublicID: string;
    Creator: { Socials?: any; Username: any; DPURL: string; };
    Title: string;
    Category: any;
    Visibility: any;
};

export function PostRenderer(props: { post: Post }) {

    //Image fix
    const para = ({ children, ...props }) => {
        const ParaComponent = children[0]?.type === 'img' ? 'div' : 'p';
        return <ParaComponent {...props}>{children}</ParaComponent>;
    };

    //Open links in new tab
    function LinkRenderer(props) {
        return <a href={props.href} target="_blank">{props.children}</a>
    }

    return (
        <>
            {props.post.BannerImage && <img src={`https://static.poly.pizza/${props.post.BannerImage}`} className='w-full h-[22rem] object-cover rounded-md rounded-b-none' />}
            <article className='flex flex-col mt-10 px-16'>
                <header>
                    <Typography variant="h4" component="h1" className="text-white-light !text-5xl !leading-tight !font-thin text-white font-mono overflow-hidden resize-none h-auto !mb-3">{props.post.Title}</Typography>
                    <div className='flex w-full justify-between items-center mb-10'>
                        <CreatorInfo Creator={props.post.Creator} className="!pl-0" />
                        <Typography variant='body2' color="textSecondary">{new Date(props.post.Posted).toDateString()}</Typography>
                    </div>
                </header>

                <Markdown
                    className='md'
                    options={{
                        overrides:
                        {
                            Model: { component: AutoPizzaViewer },
                            p: para,
                            a: LinkRenderer,
                        }
                    }}>
                    {props.post.Content}
                </Markdown>
            </article>
        </>
    );
}

